import { BuildingType } from '../buildings';
import imgOutside from '../../assets/buildings/industry/outside.png';
import imgWater from '../../assets/buildings/industry/water.png';
import imgProduction from '../../assets/buildings/industry/production.png';
import imgLab from '../../assets/buildings/industry/lab.png';
import imgFireProtection from '../../assets/buildings/industry/fire-protection.png';
import imgSprinklerCenter from '../../assets/buildings/industry/sprinkler-center.png';
import imgHeating from '../../assets/buildings/industry/heating.webp';
import imgWasteWater from '../../assets/buildings/industry/waste-water.webp';
import { BuildingArea, SubBuilding } from '../../interfaces/buildings';
import { ProductType } from '../products';
import { TechSector } from '../tech-sector';
import { activeLanguage } from '../../activeLanguage';

const industryConfig: BuildingArea = {
    techSectors: [
        ...(activeLanguage.locale.language === 'fr'
            ? []
            : [
                  {
                      type: TechSector.WASTE_WATER,
                      img: imgWasteWater,
                      buildings: [],
                      products: [
                          {
                              position: { x: 280, y: 740 },
                              type: ProductType.AMAREX,
                          },
                          {
                              position: { x: 1195, y: 530 },
                              type: ProductType.AMA_DRAINER_BOX_UNTERFLUR,
                          },
                          {
                              position: { x: 1450, y: 530 },
                              type: ProductType.AMA_DRAINER_4_5,
                          },
                          {
                              position: { x: 1545, y: 410 },
                              type: ProductType.LEVELCONTROL_BASIC_2,
                          },
                          {
                              position: { x: 1700, y: 400 },
                              type: ProductType.COMPACTA,
                          },
                      ],
                  },
              ]),
        {
            type: TechSector.FIRE_PROTECTION,
            img: imgFireProtection,
            buildings: [
                {
                        coordinates: { x: 1245, y: 388 },
                    building: BuildingType.INDUSTRY_SPRINKLER_CENTER,
                    link: `${BuildingType.INDUSTRY_SPRINKLER_CENTER}/${TechSector.FIRE_PROTECTION}`,
                    showSector: false,
                },
            ],
        },
        ...(activeLanguage.locale.language === 'fr'
            ? []
            : [
                  {
                      type: TechSector.HEATING,
                      img: imgOutside,
                      buildings: [
                          {
                              coordinates: { x: 284, y: 600 },
                              building: BuildingType.INDUSTRY_PRODUCTION,
                              link: `${BuildingType.INDUSTRY_HEATING}/${TechSector.HEATING}`,
                              showSector: false,
                          },
                      ],
                  },
              ]),
        {
            type: TechSector.WATER,
            img: imgOutside,
            buildings: [
                {
                        coordinates: { x: 284, y: 600 },
                    building: BuildingType.INDUSTRY_PRODUCTION,
                    link: `${BuildingType.INDUSTRY_PRODUCTION}/${TechSector.WATER}`,
                    showSector: false,
                },
                {
                        coordinates: { x: 700, y: 480 },
                    building: BuildingType.INDUSTRY_WATER,
                    link: `${BuildingType.INDUSTRY_WATER}/${TechSector.WATER}`,
                    showSector: false,
                },
                {
                        coordinates: { x: 1084, y: 540 },
                    building: BuildingType.INDUSTRY_LAB,
                    link: `${BuildingType.INDUSTRY_LAB}/${TechSector.WATER}`,
                    showSector: false,
                },
            ],
        },
    ],
    img: imgOutside,
};

export const industryLabConfig: SubBuilding = {
    parentBuilding: BuildingType.INDUSTRY,
    img: imgLab,
    techSectors: [
        {
            type: TechSector.WATER,
        },
    ],
    products: [
        {
                position: { x: 366, y: 655 },
            type: ProductType.KSB_SAFETY_BOOST,
        },
    ],
};

export const industryWaterConfig: SubBuilding = {
    parentBuilding: BuildingType.INDUSTRY,
    img: imgWater,
    techSectors: [
        {
            type: TechSector.WATER,
        },
    ],
    products: [
        {
                position: { x: 920, y: 633 },
            type: ProductType.DELTA_PRIMO_SVP,
        },
    ],
};

export const industryProductionConfig: SubBuilding = {
    parentBuilding: BuildingType.INDUSTRY,
    img: imgProduction,
    techSectors: [
        {
            type: TechSector.WATER,
        },
    ],
    products: [
        {
                position: { x: 1477, y: 563 },
            type: ProductType.ETANORM,
        },
        {
                position: { x: 1680, y: 542 },
            type: ProductType.BOA_COMPACT_EKB,
        },
    ],
};

export const industryTestcenterConfig: SubBuilding = {
    parentBuilding: BuildingType.INDUSTRY,
    img: imgProduction,
    techSectors: [],
    products: [],
};

export const industryHeatingCenterConfig: SubBuilding = {
    parentBuilding: BuildingType.INDUSTRY,
    img: imgHeating,
    techSectors: [
        {
            type: TechSector.HEATING,
        },
    ],
    products: [
        {
                position: { x: 592, y: 729 },
            type: ProductType.BOA_H,
        },
        {
                position: { x: 647, y: 536 },
            type: ProductType.SERIE_2000,
        },
        {
                position: { x: 1172, y: 615 },
            type: ProductType.BOA_SYSTRONIC_EPIC,
        },
        {
                position: { x: 1297, y: 407 },
            type: ProductType.ETALINE_SYT,
        },
    ],
};

export const industrySprinklerCenterConfig: SubBuilding = {
    parentBuilding: BuildingType.INDUSTRY,
    img: imgSprinklerCenter,
    techSectors: [
        {
            type: TechSector.FIRE_PROTECTION,
        },
    ],
    products: [
        {
                position: { x: 119, y: 628 },
            type: ProductType.KSB_SAFETY_BOOST,
        },
        {
                position: { x: 1193, y: 225 },
            type: ProductType.ETANORM_FXV,
        },
        {
                position: { x: 1420, y: 412 },
            type: ProductType.HYASOLO_2_D_FL_COMPACT,
        },
    ],
};

export default industryConfig;
